import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { HeaderWrapper } from '../../components/ModalResourceHeader.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import Skeleton from '@fabric-app/ui/components/Skeleton';

const BodyWrapper = styled(Flex).attrs({
  direction: "column",
  gap: 12
}).withConfig({
  displayName: "ResourceContentSkeleton__BodyWrapper",
  componentId: "sc-4f838129-0"
})([
  `padding:1.5rem;`
]);
const ResourceContentSkeleton = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(HeaderWrapper, {
        children: /* @__PURE__ */ jsx(HeaderWrapper.Left, {
          children: /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 8,
            width: 200,
            height: 24
          })
        })
      }),
      /* @__PURE__ */ jsxs(BodyWrapper, {
        children: [
          /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 8,
            height: 300
          }),
          /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 8,
            width: 300,
            height: 24
          }),
          /* @__PURE__ */ jsx(Skeleton, {
            borderRadius: 8,
            width: 190,
            height: 24
          })
        ]
      })
    ]
  });
};

export { ResourceContentSkeleton };
//# sourceMappingURL=ResourceContentSkeleton.js.map
